module.exports = __webpack_public_path__ + "static/parade-2020-house14-58c213cc2bff6a40e30a22ed5a7f91c4.jpg";